import { MouseEvent, useState } from 'react';
import { FormattedFileName } from '../../atoms/formatted-file-name';
import ButtonNew from '../button/Button';
import styles from './DocumentLink.module.css';
import { StoredFileMetadata } from '../../../api/shared/types';
import findFileSignedUrl from '../../../api/file/findFileSignedUrl';
import Notifications from '../../organisms/notifications/Notifications';
import { useTranslation } from 'react-i18next';

interface DocumentLinkProps {
    fileName: string;
    params?: StoredFileMetadata['params'];
}

const DocumentLink = ({
    fileName,
    params,
}: DocumentLinkProps) => {
    const { t } = useTranslation();

    const [ isFetchingFileSignedUrl, setIsFetchingFileSignedUrl ] = useState(false)

    const handleOnClick = async (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();

        await fetchFileSignedUrl();
    };

    const fetchFileSignedUrl = async () => {
        setIsFetchingFileSignedUrl(true);

        try {
            if (params === undefined) {
                throw new Error();
            }

            const response = await findFileSignedUrl(params);

            window.open(response.url, '_blank');
        } catch (error) {
            Notifications.add({
                message: t('documentLink.fetchFileSignedUrlError'),
                type: 'failed'
            });
        } finally {
            setIsFetchingFileSignedUrl(false);
        }
    }

    return (
        <ButtonNew
            className={styles.documentName}
            variant='link'
            onClick={handleOnClick}
            disabled={isFetchingFileSignedUrl}
        >
            <FormattedFileName
                filename={fileName}
            />
        </ButtonNew>
    );
}

export default DocumentLink;
